import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, withCtx as _withCtx, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { id: "g-modal-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalWindows, (window) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(window.windowType), _normalizeProps(_mergeProps({
                key: window.id
            }, window.windowAttrs)), {
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(window.component), _normalizeProps(_guardReactiveProps(window.componentAttrs)), null, 16))
                ]),
                _: 2
            }, 1040));
        }), 128))
    ]));
}
